/**
 * Entry for the FIXTURE build (`node build.mjs`): the J-3704 reference clone on fake data. It is
 * the only build that contains the placeholder unlocker, the fixture data and the URL review
 * hooks (`?fixture=`, `?unlock=`). The shell refuses the placeholder in front of anything but
 * fixture data, and the bundle-safety test fails if any other build contains these modules.
 */
import { boot } from "../main.js";
import { unlockerFromSearch } from "../auth/unlock.js";
import { FixtureDataSource, fixtureVariantFromSearch } from "../data/fixture-source.js";
import { FIXTURE_PINNED_FIELDS } from "../data/fixtures.js";

boot({
  dataSource: new FixtureDataSource(fixtureVariantFromSearch(location.search)),
  unlocker: unlockerFromSearch(location.search),
  pinned: FIXTURE_PINNED_FIELDS,
});
